import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-bell',
    imports: [CommonModule, MatIconModule],
    templateUrl: './bell.component.html',
    styleUrls: ['./bell.component.scss']
})
export class BellComponent implements OnChanges {
  @Input() notificationCount: number = 0;
  @Input() icon: string = 'notifications_none';
  @Input() title: string = '';
  @Input() badgeColor: string = '#ff0000'; // Default to red
  @Output() notificationClicked = new EventEmitter<void>();
  circleFontSize: string = '10px';
  circleWidth: string = '20px';
  circleHeight: string = '20px';
  circleLineHeight: string = '20px';

  onNotificationClick(): void {
    this.notificationClicked.emit();
  }

  ngOnChanges() {
    this.adjustCircleSize();
  }

  private adjustCircleSize(): void {
    const displayText = this.notificationCount > 99 ? '99+' : this.notificationCount.toString();
    const countLength = displayText.length;

    if (countLength > 2) {
      this.circleFontSize = '8px';
      this.circleWidth = '24px';
      this.circleHeight = '24px';
      this.circleLineHeight = '24px';
    } else {
      this.circleFontSize = '10px';
      this.circleWidth = '20px';
      this.circleHeight = '20px';
      this.circleLineHeight = '20px';
    }
  }
}